import gsap from 'gsap';

export default class FocusArea {
	static instance = null;

	static create() {
		if (!FocusArea.instance) {
			FocusArea.instance = new FocusArea();
		}

		return FocusArea.instance;
	}

	static destroy() {
		if (FocusArea.instance) {
			FocusArea.instance.beforeDestroy();
			FocusArea.instance = null;
		}
	}

	constructor() {
		this.isScrollingUp = false;
		this.isScrollingDown = false;
        this.speed = 0.35;
        this.ease = 'power1.out';
		this.navHeader = document.querySelector('.header-focus');
		this.lastScrollPosition = 0;
		this.init();
	}

	init() {
		if (this.navHeader) {
			this.initHeaderFocusArea();
		}
	}

	initHeaderFocusArea() {
		window.scroller.on('scroll', this.hideShowHeader.bind(this));
	}

	hideShowHeader() {
		const scroll = window.scroller.scroll.instance.scroll.y;
		if (scroll > this.navHeader.offsetHeight) {
			const scrollDelta = scroll - this.lastScrollPosition;
			if (scrollDelta > 1 && !this.isScrollingDown) {
				gsap.to(this.navHeader, {
					y: -this.navHeader.offsetHeight,
					duration: this.speed,
					ease: this.ease,
				});
				this.isScrollingDown = true;
				this.isScrollingUp = false;
			} else if (scrollDelta < -1 && !this.isScrollingUp) {
				gsap.to(this.navHeader, {
					y: 0,
					duration: this.speed,
					ease: this.ease,
				});
				this.isScrollingDown = false;
				this.isScrollingUp = true;
			}

			this.lastScrollPosition = scroll;
		}
	}

	beforeDestroy() {
		this.navHeader = null;
		this.isScrollingUp = null;
		this.isScrollingDown = null;
		this.hideShowHeader = null;
		this.initHeaderFocusArea = null;
	}
}
